import { useState } from "react";
import { homeService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { IApiRequest, IHome, IHomeListResponse } from "@miplatform/types";
import { createUUID } from "@miplatform/utils";

const getHomesUUID = createUUID();
const deleteHomeUUID = createUUID();

export const useHomes = () => {
  const stateManager = useComponentState();
  const isLoading = stateManager.isBusy();

  const [homes, setHomes] = useState<IHomeListResponse[]>([]);

  const getHomes = (params: IApiRequest<IHome> = {}): Promise<void> => {
    stateManager.abort(getHomesUUID);

    return stateManager.run(async () => {
      const res = await homeService.homes.getAll(params);

      return res;
    }, getHomesUUID);
  };

  const deleteHome = (homeId: string, modifiedOn: string): void => {
    stateManager.abort(deleteHomeUUID);
    stateManager.run(async () => {
      const response = await homeService.homes.delete({
        id: homeId,
        modifiedOn,
        toastMessageConfig: {
          success: {
            text: "Home deleted successfully.",
          },
        },
      });
      if (response.status === HTTP_STATUSES.NO_CONTENT) {
        getHomes();
      }
    }, deleteHomeUUID);
  };

  return {
    isLoading,
    homes,
    stateManager,
    getHomes,
    setHomes,
    deleteHome,
  };
};
